import { useEffect, useState } from 'react';
import { getSimilarMovements } from '../api/endpointsBackend';

/**
 * The movements similar to one movement, and whether the lookup is still
 * running. `similar` stays null until it answers, and when it fails. Without
 * an id nothing is looked up.
 */
export default function useSimilarMovements(movementId) {
  const [similar, setSimilar] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!movementId) {
      setSimilar(null);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    getSimilarMovements(movementId)
      .then(result => { if (!cancelled) setSimilar(result); })
      .catch(err => {
        console.error('Failed to load similar movements:', err);
        if (!cancelled) setSimilar(null);
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [movementId]);

  return { similar, loading };
}
